<template>
  <div>
    <div class="bg-primary">
      <div class="container">
        <ProfileNavigationMobile />
      </div>
    </div>
    <div
      class="lg:grid-cols-[250px_1fr] lg:grid lg:min-h-screen-without-header"
    >
      <ProfileNavigation />
      <div class="px-4 lg:pl-20 lg:pr-8 py-12 lg:py-20">
        <div
          class="lg:flex lg:gap-x-2 lg:items-center lg:flex-row lg:justify-between max-lg:space-y-2"
        >
          <h2 v-if="slots['page-header']" class="text-primary">
            <slot name="page-header" />
          </h2>
          <slot name="page-button" />
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const slots = useSlots();
</script>
